import React from 'react';

function SidebarItem({ icon: Icon, label, active, onClick, danger = false }) {
  const classes = [
    'mp-sidebar-item',
    active ? 'is-active' : '',
    danger ? 'is-danger' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={classes} onClick={onClick} aria-label={label}>
      <Icon className="mp-sidebar-item__icon" />
      <span>{label}</span>
    </button>
  );
}

export default SidebarItem;
